import React from "react";

import { Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";


import { Swiper, SwiperSlide } from 'swiper/react';
import {Navigation, Pagination, Scrollbar, A11y, Keyboard, Mousewheel, EffectCreative, EffectCards } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import video from "../../assets/videos/articles/montage-background-video.mp4";
import bg from "../../assets/images/articles/CAL/CAL-7.jpg";
import img1 from "../../assets/images/articles/CAL/CAL-1.jpg";
import img2 from "../../assets/images/articles/CAL/CAL-2.jpg";
import img3 from "../../assets/images/articles/CAL/CAL-3.jpg";
import img4 from "../../assets/images/articles/CAL/CAL-4.jpg";
import img5 from "../../assets/images/articles/CAL/CAL-5.jpg";
import img6 from "../../assets/images/articles/CAL/CAL-6.jpg";
import img7 from "../../assets/images/articles/CAL/CAL-7.jpg";

import slide1_1 from '../../assets/images/articles/CAL/CAL_ali-01.jpg';
import slide1_2 from '../../assets/images/articles/CAL/CAL_ali-02.jpg';
import slide1_3 from '../../assets/images/articles/CAL/CAL_ali-03.jpg';
import slide1_4 from '../../assets/images/articles/CAL/CAL_ali-04.jpg';
import slide1_5 from '../../assets/images/articles/CAL/CAL_ali-05.jpg';
import slide1_6 from '../../assets/images/articles/CAL/CAL_ali-06.jpg';
import slide1_7 from '../../assets/images/articles/CAL/CAL_ali-07.jpg';
import slide1_8 from '../../assets/images/articles/CAL/CAL_ali-08.jpg';
import slide1_9 from '../../assets/images/articles/CAL/CAL_ali-09.jpg';
import slide1_10 from '../../assets/images/articles/CAL/CAL_ali-10.jpg';
import slide1_11 from '../../assets/images/articles/CAL/CAL_ali-11.jpg';
import slide1_12 from '../../assets/images/articles/CAL/CAL_ali-12.jpg';
import slide1_13 from '../../assets/images/articles/CAL/CAL_ali-13.jpg';
import slide1_14 from '../../assets/images/articles/CAL/CAL_ali-14.jpg';
import slide1_15 from '../../assets/images/articles/CAL/CAL_ali-15.jpg';

import slide2_1 from '../../assets/images/articles/CAL/CAL_scan-01.jpg';
import slide2_2 from '../../assets/images/articles/CAL/CAL_scan-02.jpg';
import slide2_3 from '../../assets/images/articles/CAL/CAL_scan-03.jpg';
import slide2_4 from '../../assets/images/articles/CAL/CAL_scan-04.jpg';
import slide2_5 from '../../assets/images/articles/CAL/CAL_scan-05.jpg';
import slide2_6 from '../../assets/images/articles/CAL/CAL_scan-06.jpg';
import slide2_7 from '../../assets/images/articles/CAL/CAL_scan-07.jpg';
import slide2_8 from '../../assets/images/articles/CAL/CAL_scan-08.jpg';
import slide2_9 from '../../assets/images/articles/CAL/CAL_scan-09.jpg';
import slide2_10 from '../../assets/images/articles/CAL/CAL_scan-10.jpg';
import slide2_11 from '../../assets/images/articles/CAL/CAL_scan-11.jpg';
import slide2_12 from '../../assets/images/articles/CAL/CAL_scan-12.jpg';
import slide2_13 from '../../assets/images/articles/CAL/CAL_scan-13.jpg';
import slide2_14 from '../../assets/images/articles/CAL/CAL_scan-14.jpg';
import slide2_15 from '../../assets/images/articles/CAL/CAL_scan-15.jpg';
import slide2_16 from '../../assets/images/articles/CAL/CAL_scan-16.jpg';
import slide2_17 from '../../assets/images/articles/CAL/CAL_scan-17.jpg';
import slide2_18 from '../../assets/images/articles/CAL/CAL_scan-18.jpg';
import slide2_19 from '../../assets/images/articles/CAL/CAL_scan-19.jpg';
import slide2_20 from '../../assets/images/articles/CAL/CAL_scan-20.jpg';
import slide2_21 from '../../assets/images/articles/CAL/CAL_scan-21.jpg';
import slide2_22 from '../../assets/images/articles/CAL/CAL_scan-22.jpg';
import slide2_23 from '../../assets/images/articles/CAL/CAL_scan-23.jpg';
import slide2_24 from '../../assets/images/articles/CAL/CAL_scan-24.jpg';
import slide2_25 from '../../assets/images/articles/CAL/CAL_scan-25.jpg';
import slide2_26 from '../../assets/images/articles/CAL/CAL_scan-26.jpg';
import slide2_27 from '../../assets/images/articles/CAL/CAL_scan-27.jpg';
import slide2_28 from '../../assets/images/articles/CAL/CAL_scan-28.jpg';
import slide2_29 from '../../assets/images/articles/CAL/CAL_scan-29.jpg';
import slide2_30 from '../../assets/images/articles/CAL/CAL_scan-30.jpg';
import slide2_31 from '../../assets/images/articles/CAL/CAL_scan-31.jpg';
import slide2_32 from '../../assets/images/articles/CAL/CAL_scan-32.jpg';
import slide2_33 from '../../assets/images/articles/CAL/CAL_scan-33.jpg';
import slide2_34 from '../../assets/images/articles/CAL/CAL_scan-34.jpg';
import slide2_35 from '../../assets/images/articles/CAL/CAL_scan-35.jpg';
import slide2_36 from '../../assets/images/articles/CAL/CAL_scan-36.jpg';
import slide2_37 from '../../assets/images/articles/CAL/CAL_scan-37.jpg';
import slide2_38 from '../../assets/images/articles/CAL/CAL_scan-38.jpg';
import slide2_39 from '../../assets/images/articles/CAL/CAL_scan-39.jpg';
import slide2_40 from '../../assets/images/articles/CAL/CAL_scan-40.jpg';
import slide2_41 from '../../assets/images/articles/CAL/CAL_scan-41.jpg';
import slide2_42 from '../../assets/images/articles/CAL/CAL_scan-42.jpg';
import slide2_43 from '../../assets/images/articles/CAL/CAL_scan-43.jpg';





import downloadArticle from '../../assets/pdf/article_Notes-on-Club-Acces-Lab_Tilde-De-Vylder.pdf';

const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "white",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 400,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid black",
      borderRadius: "1px",
    },
  })
);

function CAL() {
  return (
    <div className="CAL" id="background">
      <div className="CAL__backgroundVideo">
        <div className="CAL__backgroundVideo__wrapper">
          <div className="CAL__backgroundVideo__title">
            <h1 className="editH1">NOTES ON ’CLUB ACCESS LAB’</h1>
            <h2 className="editH2">Tilde De Vylder | 08.04.2025</h2>
          </div>
        </div>
        <img src={bg} className="CAL_bg_img" alt="" />
        {/* <video src={video} width="100%" height="auto" loop autoPlay muted playsInline></video> */}
      </div>

      <div className="CAL__container">
        <div className="CAL__container__title">
          <h1 className="editH1">NOTES ON ’CLUB ACCESS LAB’</h1>
          <h2 className="editH2">Tilde De Vylder | 08.04.2025</h2>
        </div>

        <div className="CAL__container__intro">
          <div className="CAL__intro__img">
            <img src={img1} alt="" />
            <p className="credit__margin"> @Simon Breynaert </p>
          </div>

          <div className="CAL__intro__text">
            About a month ago - somewhere mid February - Club Dérive, Dancefloor Intimacy and Montage launched an open
            call for their ‘<mark>Club Access Lab</mark>’. Together, in the weekend of the 7-9th March, they would host a workshop on
            accessible club design - the theme where the practices of the three collectives intersect.
          </div>
        </div>

        <div className="CAL__container__bigImg">
          <img className="CAL__big__img" src={img2} alt="" />
          <p className="credit__margin"> @Simon Breynaert </p>
        </div>

        <div className="CAL__container__body pad__top">
          <div className="CAL__body__text">
            <div>
              On the one hand there is <mark>Dancefloor Intimacy</mark>, a London based ‘movement’ putting a broad understanding of
              ‘accessibility’ at the forefront of a vibrant nightlife culture. By gathering the lived experiences of
              clubgoers - a group which bans no disability or neurodiversity - and allowing them to unleash their
              imagination, Dancefloor Intimacy bridges the gap between research and actionable change, thus between the
              current - excluding - and optimal - inclusive - situations. In this endeavour, <mark>Club Dérive</mark>, is the perfect
              partner in crime. With space as their instrument and by relying on psychogeographic theories, CD's
              scenographies aim to be more than installations. Rather they are ‘<i>ambiances</i>’ - animated and appropriable
              settings, resulting from and at the same time stimulating an intense interaction between the objective
              environment and the individual subject. In the same way CD’s scenographies are <i>not just installations</i>, <mark>Montages</mark> events 
              aim to be <i>not just parties</i>. With every event, <mark>Laura Conant and Jonathan Cant</mark> - founders of
              Montage - try to radically shift club conventions: however crazy an idea, it is never too crazy to
              explore.
              <br />
              <br />
              On the part of Dancefloor Intimacy, there’s founder <mark>Ali Wagner</mark> - trained as product and industrial designer, 
              focussing on social and environmental strategies for the nightlife and music industry - and for 
              Club Dérive, there’s <mark>Clara Golfa Sambay</mark> - an Environmental and Prevention Management student - leading the Lab.
              <br />
              <br />
              The joint workshop is then a <i>trialogue</i> in which two questions prevail: 
              <div className="CAL__body__text__middle__incline">
                <br />a) what does a utopian clubbing experience look like? and 
                <br />b) how do we build it? 

              </div>
              <br />To guide our thoughts, giving a clear direction to the
              experiment, our answers to these questions are to be translated into <mark>concrete design interventions, with
              the next Montage party in Recyclart</mark> - a multidisciplinary art, culture and club space in Molenbeek - <mark>as
              case study.</mark>
              <br />
              <br />
              During the course of three days, we went from reality to utopia and back, balancing options and
              constraints, weighing out problems and solutions, navigating between past, present, future. The <mark>first day</mark> was 
              all about establishing the theoretical framework on which to build. Ali laid out some central notions
              for understanding accessibility and disability: we talked about definitions and misconceptions, learned
              about the spoon theory and the notion of universal design, pinned the social model of disability against
              the medical one. (I won’t go into detail about these concepts here, but strongly encourage you to google
              them.) Armed with this theoretical foundation, we set out to do an <i>in situ</i> audit of Recyclart, aiming to
              understand the barriers that exist for people with access needs.
              <br />
              <br />
              Identifying possible solutions for these barriers was the goal of the <mark>second day</mark>. With a post-it-exercise 
              on how to turn theory into action, Clara guided us towards a collective brainstorm session. This session was set up as 
              an exercise in stimulating behaviour change, encouraging us to approach design with greater awareness for accessibility. 
              Gently we entered the realm of ideas, putting words and giving shapes to our own ultimate utopian club experiences - no
              scenario being too far-fetched, no fantasies too far-stretched.
              <br />
              <br />
              On <mark>Sunday</mark> our rather floaty proposals were to land, in order to arrive at concrete designs with distinct
              forms and clear materiality.
              <br />
              <br />
              Joining the workshop was a motley group of about <mark>15 individuals</mark>, all as creative as colourful. Many have
              backgrounds in architecture and art, but there’s also experience in film, theatre, (health)care and gender
              studies. The multidisciplinary gang also brings with it a multi-layered reading of the world, due to their
              non-conforming engagement with it.
              <br />
              <br />
              As a way of reflecting on this workshop, I gathered five overarching insights that struck me throughout
              the weekend, and continue to stuck with me. By not opting for a detailed report of our work, but rather
              choosing to share these lessons, I hope to spark your imagination. In this way, the Club Access Lab is an
              unending endeavour - and the experiment can keep going.
            </div>
          </div>
          <div className="CAL__body__image">
            <img src={img3} alt="" />
          </div>
        </div>

        <div className="CAL__container__body">
          <div className="CAL__body__text__quote">
            <h2>"from reality to utopia and back"</h2>
          </div>
        </div>

        <div className='CAL__container__swiper'>
          <div className='CAL__container__swiper_s'>
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={20}
                slidesPerView={3}
                loop={true}
                centeredSlides={true}
                keyboard={{
                    enabled: true,
                }}
                mousewheel={true}
                grabCursor={true}
                navigation
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide><img src={slide1_1} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_2} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_3} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_4} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_5} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_6} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_7} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_8} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_9} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_10} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_11} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_12} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_13} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_14} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide1_15} alt="" /></SwiperSlide>
            </Swiper>
          </div>
          <p className="credit__margin"> @Ali Wagner </p>
        </div>


        <div className="CAL__container__body">
          <div className="CAL__body__text__middle" id="get__H2">
            <h2>EVERYTHING ALWAYS STARTS WITH LANGUAGE</h2>
            Finding yourself in a group of strangers, especially when you know you will be spending the next three days
            with them, is always a bit uncomfortable. The weight of making a good first impression can be heavy, but
            was, thanks to Ali and the CD members, immediately made a bit lighter. In presenting ourselves, we were
            asked for our pronouns and motivations. Stating why we wanted to join this specific workshop meant shedding
            a personal layer. Laying a vulnerability on the table and realising that there is space for that,
            immediately makes you feel more at ease. This aspect, together with clear communication about some rules -
            or rather desired behaviours -, contributes to the establishment of every safer space. We then went on to
            define the appropriate jargon - f.e. how we talk about people with certain disabilities. This linguistic
            clarity and transparency of information and communication on multiple levels - about correct vocabulary,
            about the planning, about the space, about ourselves and each other - created an immediate feeling of
            calmness. I felt welcome, at ease, safe.
            <br />
            <br />
            Our designs - on day 2 - also departed from language. Having identified persisting barriers in Recyclart, we
            started to put into words our desired feelings and experiences. Wishes became words and words turned into
            concepts. Collectively, we realised that the design of an accessible club is about emotions and discovered
            wordplay as the ultimate scenographical strategy - a <mark>shared</mark> understanding stemming from our <mark>differences</mark>.
          </div>
        </div>

        <div className="CAL__container__body">
          <div className="CAL__body__text">
            <h2 id="get__H2">NOTHING GOOD EVER COMES FROM THINKING IN(SIDE) BOXES</h2>
            <div>
              A correct and inclusive reading of our physical environment starts by realising that the world as we know
              it is, for the most part, made by and thus made for one type of person: the white, neurotypical and
              straight male, with an average height and average weight, and no visible nor invisible disability. This,
              of course, poses problems for the majority of people, who do not conform to this norm, so on a fundamental
              level, our physical world is not made to accommodate to variety and diversity. Pursuing accessibility
              means being conscious of the ubiquity of barriers… and especially of their anonymity. Through the concept
              of intersectionality we know that no human will ever know <mark>all</mark> barriers, since there’s as many personal
              experiences as there is people on this earth.
              <br />
              <br />
              Creating accessible spaces means overthrowing the conventions we have grown up with. Change can only occur
              by thinking outside the normative box. Inclusivity can only come from diversity: we need multitudes to
              tackle the issue of accessibility.
            </div>
          </div>
          <div className="CAL__body__image">
            <img src={img4} alt="" />
          </div>
        </div>

        <div className="CAL__container__imgRow">
          <img className="CAL__imgRow__img" src={img5} alt="" />
        </div>
        <p className="credit__margin"> @Simon Breynaert </p>


        <div className="CAL__container__body">
          <div className="CAL__body__text__middle pad__top" id="get__H2">
            <h2 id="get__H2">ACCESSIBILITY MEANS GIVING PEOPLE OPTIONS</h2>
            Though accessibility shouldn’t be an issue… Today, focussing on accessibility mostly means finding solutions
            to a problem, but what is deemed ‘problematic’ is often arbitrary. Think about the social model of
            disability, for example, which states, contrary to <mark>medical</mark> beliefs, that the disability of a person is
            itself not a problem, but that the world as it exists poses problems for the disabled. Therefore just
            overthrowing the convention - solely looking for answers to questions - is not enough: accessibility should
            be seen as a premise, a potentiality, a catalyst for social equality and interconnectedness. ‘Accessible’ is
            then not just an adaptation of a certain standard, but means making stuff that from the start benefits
            everyone and can be <mark>appropriated</mark>, though should never have to be <mark>adapted</mark>.
            <br />
            <br />
            Two of Ali’s aphorisms I will from now on take with me in everything I make - and I hope we all do. 
            <div className="CAL__body__text__middle__incline">
              <br /> a) Designing for the minority means designing for the majority. 
              <br /> b) Accessibility means giving people options. 
            </div>
            (Not so coincidentally, this second point - of working towards maximum ‘variety’ - is also
            reflected in Club Dérives ‘design tactics'.)
          </div>
        </div>

        <div className="CAL__container__body">
          <div className="CAL__body__text CAL__body__text__mobile">
            <h2 id="get__H2">
              SOMETIMES PROCESS AND PRODUCT ARE NOT MEANS AND END, BUT ARE TWO SIDES OF THE SAME COIN
            </h2>
            <div>
              In a way, the whole weekend was a metaphor for what we would like our (club) experiences to be. When we
              describe our utopian club nights, we speak of smooth transitions - be it in music, space, lights,
              materials -, of being clearly informed, of diverse and nice people, of feeling as if we’re part of one
              organic collective choreography, of not being abruptly interrupted, of being taken care of… One time
              throughout the workshop we were presenting individual proposals to the group, and it was almost as if we
              had beforehand agreed on who would talk after who. We seemed to follow a choreo that no one knew about…
              which was sweet to witness.
              <br />
              <br />I truly believe that process and product are not separate modes of production. Rather they are two
              sides of the same coin. This insight is therefore an ode to a kind of coherence that is crucial in all we
              endeavour to do. If you want your designs to be accessible, make sure your practice is too. If you want
              your projects to be nice, make sure you are too. Creation is a matter of honesty - what you want your
              designs to achieve should be reflected in the process of achieving it. I am convinced this is one of the
              most interesting design strategies in general.
            </div>
          </div>
          <div className="CAL__body__image CAL__body__image__opencall">
            <img src={img6} alt="" />
          </div>
        </div>

        <div className='CAL__container__swiper'>
          <div className='CAL__container__swiper_s'>
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={20}
                slidesPerView={3}
                loop={true}
                centeredSlides={true}
                keyboard={{
                    enabled: true,
                }}
                mousewheel={true}
                grabCursor={true}
                navigation
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log('slide change')}
            >
              <SwiperSlide><img src={slide2_1} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_2} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_3} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_4} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_5} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_6} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_7} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_8} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_9} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_10} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_11} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_12} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_13} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_14} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_15} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_16} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_17} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_18} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_19} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_20} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_21} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_22} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_23} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_24} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_25} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_26} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_27} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_28} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_29} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_30} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_31} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_32} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_33} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_34} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_35} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_36} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_37} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_38} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_39} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_40} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_41} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_42} alt="" /></SwiperSlide>
              <SwiperSlide><img src={slide2_43} alt="" /></SwiperSlide>
            </Swiper>
          </div>
        </div>

        <div className="CAL__container__body">
          <div className="CAL__body__text__middle" id="get__H2">
            <h2 id="get__H2">DEBORD IS NOT DEAD</h2>
            Club Dérive roots their practice in Situationist beliefs - the bulk of whose thinking was published under
            Guy Debords name, somewhat 60 years ago. Debord died in 1994… but seemed throughout the weekend still very
            much alive. At multiple times I was reminded of the concepts he - or rather the <mark>Situationist International</mark> in general - posited and the books they wrote.
            <br />
            <br />
            <div className="CAL__body__text__middle__incline">
              a) Situationists famously rebelled against the pervasive power of consumer society and wanted to overthrow
              all prevailing artistic and social norms - as they only slavishly contributed to the status quo. Their
              technique of <mark>détournement</mark> was to do exactly that: turn the situation around, overturn the existing
              conventions. In this same way, designing accessibly also means going against the norm, against persisting
              standards.
              <br />
              <br />
              b) Next to that, we saw a Situationist disapproval of capitalist society reflected into our own
              objections towards today's economically driven club culture. More than once we stumbled upon the financial
              limits of truly accomplishing accessibility in nightlife. The economic reality of the club scene too often
              dismisses its social potential… But what if profits would not be solely financially defined, but also
              socially and culturally?
              <br />
              <br />
              c) The SI also theorised the science of <mark>psychogeography</mark> - i.e. the study of ‘the specific effects of
              geographical environments on the emotions and behaviour of individuals.’ Not only was our visit to Recyclart
              and our reading of the barriers and options of the space a truly psychogeographic endeavour, everything we
              designed followed from anticipating their emotional and behavioural impacts. In this way, concept, cause and
              effect were radically intertwined.
              <br />
              <br />
              d) Lastly, there is the idea of <mark>dérive</mark> - which Club Derive's name pays homage to. For the Situationists, a
              dérive (‘drift’) is another way to overthrow norms, as it is an unplanned journey through space, solely lead
              by the conditions of the environment, which dissolves our everyday attitude towards it. I imagine our
              desired club experiences to be this kind of aimless non-everyday drifting. Designing an accessible club then
              means actively creating environments in which we can all dérive away.
            </div>

            <br />
            <br />
            <br />
            If you are curious to see the concrete results of the Club Access Lab, then Montage’s party in Recyclart is
            something to look forward too. Hopefully we will see each other there, ready to drift around the club,
            guided, carried, held by the scenography.
          </div>
        </div>



        <div className="CAL__container__body">
          <div className="CAL__body__text__middle middle__center" id="get__H2">
            Biggest thank you to all the participants & Ali Wagner for the assistance!
            <br /> <br />
            Tilde, Yoni, Max, Luc, Sharon, Melis, Arnaud, Jasmine and Irene
            <br /><br /><br />
            This Residency was subsidised by <a href="https://www.instagram.com/afondsbrussels/">@afondsbrussels</a>
          
          </div>
        </div>

        <div className="CAL__container__body">
          <div className="CAL__body__text__middle middle__center" id="get__H2">
            <div className="display__flex">
              <div className="article__download__button">
                <a href={downloadArticle} download="article_Notes-on-Club-Acces-Lab_Tilde-De-Vylder">Download Article</a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default CAL;
